import { render, staticRenderFns } from "./PageNotFound.vue?vue&type=template&id=619e5f02&"
import script from "./PageNotFound.vue?vue&type=script&lang=ts&"
export * from "./PageNotFound.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('619e5f02')) {
      api.createRecord('619e5f02', component.options)
    } else {
      api.reload('619e5f02', component.options)
    }
    module.hot.accept("./PageNotFound.vue?vue&type=template&id=619e5f02&", function () {
      api.rerender('619e5f02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/PageNotFound.vue"
export default component.exports